import AbstractCalls from "./AbstractCalls";

class CommonCalls extends AbstractCalls {
  sleep(timeout) {
    return new Promise((resolve) => setTimeout(resolve, timeout));
  }

  ping(body, options) {
    const cmdUri = AbstractCalls.buildCallUri("main", "sys/ping");
    return AbstractCalls.get(cmdUri, body, options);
  }

  appLoad(body, options) {
    const cmdUri = AbstractCalls.buildCallUri("main", "app/load");
    return AbstractCalls.get(cmdUri, body, options);
  }

  register(body, options) {
    const cmdUri = AbstractCalls.buildCallUri("main", "user/register");
    return AbstractCalls.post(cmdUri, body, options);
  }

  login(body, options) {
    const cmdUri = AbstractCalls.buildCallUri("main", "user/login");
    return AbstractCalls.post(cmdUri, body, options);
  }

  logout(body, options) {
    const cmdUri = AbstractCalls.buildCallUri("main", "user/logout");
    return AbstractCalls.post(cmdUri, body, options);
  }

  refreshToken(body, options) {
    const cmdUri = AbstractCalls.buildCallUri("main", "user/refreshToken");
    return AbstractCalls.post(cmdUri, body, options);
  }

  changePassword(body, options) {
    const cmdUri = AbstractCalls.buildCallUri("main", "user/changePassword");
    return AbstractCalls.post(cmdUri, body, options);
  }

  resetPassword(body, options) {
    const cmdUri = AbstractCalls.buildCallUri("main", "user/resetPassword");
    return AbstractCalls.post(cmdUri, body, options);
  }

  changePasswordByReset(body, options) {
    const cmdUri = AbstractCalls.buildCallUri("main", "user/changePasswordByReset");
    return AbstractCalls.post(cmdUri, body, options);
  }

  verifyRegistration(body, options) {
    const cmdUri = AbstractCalls.buildCallUri("main", "user/verifyRegistration");
    return AbstractCalls.post(cmdUri, body, options);
  }

  updateMetadata(body, options) {
    const cmdUri = AbstractCalls.buildCallUri("main", "user/updateMetadata");
    return AbstractCalls.post(cmdUri, body, options);
  }

  listUsers(body, options) {
    const cmdUri = AbstractCalls.buildCallUri("main", "user/list");
    return AbstractCalls.get(cmdUri, body, options);
  }

  /**
   * Loads a single user by username or userId.
   * @param {{ username?: string, userId?: string }} body
   * @param {Object} [options]
   */
  getUser(body, options) {
    const cmdUri = AbstractCalls.buildCallUri("main", "user/get");
    return AbstractCalls.get(cmdUri, body, options);
  }

  changeUsername(body, options) {
    const cmdUri = AbstractCalls.buildCallUri("main", "user/changeUsername");
    return AbstractCalls.post(cmdUri, body, options);
  }

  grantPermission(body, options) {
    const cmdUri = AbstractCalls.buildCallUri("main", "permission/grant");
    return AbstractCalls.post(cmdUri, body, options);
  }

  revokePermission(body, options) {
    const cmdUri = AbstractCalls.buildCallUri("main", "permission/revoke");
    return AbstractCalls.post(cmdUri, body, options);
  }

  /**
   * Lists permissions for a user (defaults to session user when user omitted).
   * @param {{ user?: string }} body
   * @param {Object} [options]
   */
  listPermissions(body, options) {
    const cmdUri = AbstractCalls.buildCallUri("main", "permission/list");
    return AbstractCalls.get(cmdUri, body, options);
  }

  getMappings(body, options) {
    const cmdUri = AbstractCalls.buildCallUri("main", "sys/getMappings");
    return AbstractCalls.get(cmdUri, body, options);
  }

  sudoUsername(body, options) {
    const cmdUri = AbstractCalls.buildCallUri("main", "registration/sudoUsername");
    return AbstractCalls.post(cmdUri, body, options);
  }
}

export default new CommonCalls();
